import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import {
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Spinner,
} from "reactstrap";
import { toast } from "react-toastify";
import { apiUrl } from "../../../ApiHelper/ApiUrl";
import ErrorMessage from "../../../components/comman/ErrorMessage";
import { callApi } from "../../../ApiHelper/ApiHelper";

const AddCustomerCompanyModal = ({
  modal,
  toggle,
  modalData,
  customerId,
  GetCustomerCompanyList,
}) => {
  // console.log("modalData>>>>>>>>",modalData);
  const [isLoading, setIsLoading] = useState(false);
  const {
    register,
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    if (modalData) {
      reset({
        companyName: modalData?.companyName,
        email: modalData?.email,
        phone: modalData?.phone,
        gst: modalData?.gst,
        address: modalData?.address,
      });
    } else {
      reset({
        companyName: "",
        email: "",
        phone: "",
        gst: "",
        address: "",
      });
    }
  }, [modalData, reset]);

  const closeHandler = () => {
    toggle();
    reset();
  };

  const onSubmit = (data) => {
    const submitData = {
      companyName: data?.companyName,
      email: data?.email,
      phone: data?.phone,
      gst: data?.gst,
      address: data?.address,
      customerId: customerId,
    };

    const options = {
      method: "POST",
      data: submitData,
    };

    let API = modalData
      ? apiUrl?.update_customer_company + `?customerCompanyId=${modalData?.id}`
      : apiUrl?.add_customer_company;
    setIsLoading(true);
    callApi(API, options).then((response) => {
      setIsLoading(false);
      if (response?.status === true) {
        toast.success(response?.message);
        closeHandler();
        GetCustomerCompanyList(customerId);
      } else {
        toast.error(response?.message);
      }
    });
  };

  return (
    <Modal
      className="modal-dialog  modal-dialog-centered"
      isOpen={modal}
      toggle={closeHandler}
      centered
    >
      <ModalHeader toggle={closeHandler}>
        <h4>{modalData?.id ? "Update" : "Add"} Customer Company</h4>
      </ModalHeader>

      <form onSubmit={handleSubmit(onSubmit)}>
        <ModalBody className=" p-4">
          <div className="modal-content">
            <div className="row">
              <div className="col-12">
                <div className="form-group mb-3">
                  <label htmlFor="erning" className="form-label">
                    Company Name
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Company Name"
                    {...register("companyName", {
                      required: "This field is Required",
                    })}
                  />
                </div>
                <ErrorMessage message={errors?.companyName?.message} />
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <div className="form-group mb-3">
                  <label htmlFor="erning" className="form-label">
                    Email
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter email"
                    {...register("email", {
                      required: "This field is Required",
                      pattern: {
                        value:
                          /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/i,
                        message: "Invalid email address",
                      },
                    })}
                    onChange={(e) => {
                      const trimmedEmail = e.target.value.trim().toLowerCase();
                      setValue("email", trimmedEmail, {
                        shouldValidate: true,
                      });
                    }}
                    onBlur={(e) => {
                      const trimmedEmail = e.target.value.trim();
                      setValue("email", trimmedEmail, {
                        shouldValidate: true,
                      });
                    }}
                  />
                </div>
                <ErrorMessage message={errors?.email?.message} />
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <div className="form-group mb-3">
                  <label htmlFor="phone" className="form-label">
                    Phone
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter phone"
                    maxLength={10}
                    {...register("phone", {
                      required: "This field is required",
                      pattern: {
                        value: /^[0-9]{10}$/,
                        message: "Phone number must be exactly 10 digits",
                      },
                    })}
                  />
                </div>
                <ErrorMessage message={errors?.phone?.message} />
              </div>
            </div>

            <div className="row">
              <div className="col-12">
                <div className="form-group mb-3">
                  <label htmlFor="erning" className="form-label">
                    GST
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="GST"
                    {...register("gst", {
                      required: "This field is Required",
                    })}
                  />
                </div>
                <ErrorMessage message={errors?.gst?.message} />
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <div className="form-group mb-3">
                  <label htmlFor="erning" className="form-label">
                    Address
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Address"
                    {...register("address", {
                      required: "This field is Required",
                    })}
                  />
                </div>
                <ErrorMessage message={errors?.address?.message} />
              </div>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            className="btn btn-secondary"
            onClick={closeHandler}
          >
            Close
          </button>
          <button type="submit" className="btn btn-primary">
            {isLoading ? <Spinner /> : modalData?.id ? "Update" : "Add"}
          </button>
        </ModalFooter>
      </form>
    </Modal>
  );
};

export default AddCustomerCompanyModal;
